import { Link } from "react-router-dom";
import { Flame, Instagram, Facebook, Mail, Phone, MapPin } from "lucide-react";

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 md:gap-8">
          {/* Brand */}
          <div className="space-y-4">
            <div className="flex items-center gap-2">
              <Flame className="h-6 w-6 text-orange-600" />
              <span className="text-xl font-bold text-white tracking-tight">
                SPIRO<span className="text-orange-600">TECHNIEK</span>
              </span>
            </div>
            <p className="text-sm leading-relaxed text-gray-400">
              Uw specialist in duurzame klimaatoplossingen. Van airconditioning tot warmtepompen, wij zorgen voor comfort in huis en bedrijf.
            </p>
            <div className="flex space-x-4 pt-2">
              <a href="#" className="text-gray-400 hover:text-orange-500 transition-colors"><Instagram className="h-5 w-5" /></a>
              <a href="#" className="text-gray-400 hover:text-orange-500 transition-colors"><Facebook className="h-5 w-5" /></a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">Direct naar</h3>
            <ul className="space-y-2">
              <li><Link to="/" className="hover:text-orange-500 transition-colors">Home</Link></li>
              <li><Link to="/diensten" className="hover:text-orange-500 transition-colors">Onze Diensten</Link></li>
              <li><Link to="/projecten" className="hover:text-orange-500 transition-colors">Projecten</Link></li>
              <li><Link to="/blog" className="hover:text-orange-500 transition-colors">Kennisbank & Blog</Link></li>
              <li><Link to="/offerte" className="hover:text-orange-500 transition-colors font-semibold text-orange-500">Offerte Aanvragen</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-white font-semibold mb-4">Contact</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <Phone className="h-5 w-5 text-orange-600 shrink-0" />
                <a href="tel:+31658850981" className="hover:text-white transition-colors">+31 6 58850981</a>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="h-5 w-5 text-orange-600 shrink-0" />
                <a href="mailto:info@spirotechniek.site" className="hover:text-white transition-colors">info@spirotechniek.site</a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="h-5 w-5 text-orange-600 shrink-0" />
                <span>Lelystad & Regio Flevoland</span>
              </li>
            </ul>
          </div>

          {/* Certifications / Extra */}
          <div>
            <h3 className="text-white font-semibold mb-4">Erkend Specialist</h3>
            <p className="text-sm text-gray-400 mb-4">
              Gecertificeerd Climate Control specialist | Elektricien | Loodgieter
            </p>
            <div className="bg-gray-800 p-4 rounded-lg">
              <p className="text-xs text-gray-500">
                &copy; {new Date().getFullYear()} SpiroTechniek B.V.<br />
                KvK geregistreerd.
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
